export enum DocumentStatusFilter{
    All = 'all',
    Complete = 'complete',
    Pending = 'pending',
    InProgress = 'in progress',
    Canceled = 'canceled',
    Declined = 'declined'
}